export default "__VITE_PUBLIC_ASSET__ca32e962__"